import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import 'style/components/resources/credential-card-alert.scss';


/**
 * Component to show the chart with the CredentialCardAlert
 */
class CredentialCardAlert extends Component {

    static propTypes = {
        accounts: PropTypes.array, // The accounts to draw
        type:     PropTypes.string, // (success || warning) depends of the credentials of the accounts
        onClick:  PropTypes.func // Function when the user clicks on any account link
    };

    componentWillMount() {
        this.handleOnClickAccount = this.handleOnClickAccount.bind(this);
    }

    handleOnClickAccount(e, account) {
        const {onClick} = this.props;

        onClick && onClick(account);
    }

    render() {
        const {accounts, type, intl:{formatMessage} } = this.props;

        const addCredentialTooltip = formatMessage({id: 'discover.addCredential.title'});


        if (type === 'success') {
            return (
                <div className={'card-alert'}>
                    {accounts.map(account =>
                        <div className={'item'} key={account.id}>{account.name || account.accountName}</div>
                    )}
                </div>
            );
        }

        return (
            <div className={'card-alert'}>
                {accounts.map(account =>
                    <div className="item link" title={addCredentialTooltip} onClick={e => this.handleOnClickAccount(e, account)} key={account.id}>{account.name || account.accountName}</div>
                )}
            </div>
        );
    }
}

export default injectIntl(CredentialCardAlert);





// WEBPACK FOOTER //
// ./src/components/resources/CredentialCardAlert.jsx